import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Alert,
  Button,
  Icon,
  SocialMediaIcon,
  SocialMediaIconProps,
} from '@kontentino/ui';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons/faArrowUpRightFromSquare';
import Link from 'components/shared/Link';
import PageTypeUtils from 'app/utils/pageType';
import { PageData } from 'types/Page';
import { getYtLogoGuidelineSize } from 'app/utils/getytlogoguidelinesize';

type Props = {
  urlToOpen: string;
  label: string;
  projectName?: string;
  dataNamePrefix: string;
  page: PageData | undefined;
  infoMessage?: string;
  warningMessage?: string | null;
};

const ShiftTargetSuccessful: FC<Props> = ({
  urlToOpen,
  page,
  label = 'Show post',
  projectName,
  dataNamePrefix,
  infoMessage,
  warningMessage,
}) => {
  const { t } = useTranslation();
  return (
    <div
      data-cy="duplicate-posts-modal_successful-duplicate"
      className="tw-flex tw-flex-col tw-gap-2 tw-rounded tw-bg-grayscale-20 tw-p-4"
    >
      <div className="tw-flex">
        <div>
          <div className="tw-flex tw-items-center">
            <div className="tw-ml-1 tw-flex tw-items-center tw-text-md">
              <span className="tw-font-semibold">{t('page')}:</span>
              <div className="tw-ml-2 tw-flex tw-items-center tw-gap-1">
                {page && (
                  <SocialMediaIcon
                    type={
                      PageTypeUtils.getName(
                        page.type,
                      ) as SocialMediaIconProps['type']
                    }
                    size={getYtLogoGuidelineSize(14, page.type)}
                  />
                )}

                <span className="tw-max-w-[400px] tw-truncate tw-text-md tw-font-bold">
                  {page?.name ?? t('unknownPage')}
                </span>
              </div>
            </div>
          </div>
          <div className="tw-ml-1 tw-mt-1 tw-flex tw-items-center tw-gap-1 tw-text-md">
            <span className="tw-font-semibold">{t('contentPlan')}:</span>
            <span>{projectName ?? t('unknownContentPlan')}</span>
          </div>
        </div>
        <div className="tw-ml-auto tw-shrink-0 tw-self-center">
          <Link
            to={urlToOpen}
            target="_blank"
            data-name={`${dataNamePrefix}_success_show-post`}
            data-cy={`${dataNamePrefix}_success_show-post`}
          >
            <Button iconBefore={<Icon icon={faArrowUpRightFromSquare} />}>
              {label}
            </Button>
          </Link>
        </div>
      </div>
      {!!infoMessage?.length && <Alert>{infoMessage}</Alert>}
      {!!warningMessage?.length && (
        <Alert variant="warning">{warningMessage}</Alert>
      )}
    </div>
  );
};

export default ShiftTargetSuccessful;
